/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Linux_Arm_Deb_DescInputs */

const en_pc_dl_file_linux_arm_deb_desc = /** @type {(inputs: Pc_Dl_File_Linux_Arm_Deb_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debian, Ubuntu and derivatives on ARM.`)
};

const zh_pc_dl_file_linux_arm_deb_desc = /** @type {(inputs: Pc_Dl_File_Linux_Arm_Deb_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于 ARM 上的 Debian、Ubuntu 及衍生版。`)
};

/**
* | output |
* | --- |
* | "Debian, Ubuntu and derivatives on ARM." |
*
* @param {Pc_Dl_File_Linux_Arm_Deb_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_linux_arm_deb_desc = /** @type {((inputs?: Pc_Dl_File_Linux_Arm_Deb_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Linux_Arm_Deb_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_linux_arm_deb_desc(inputs)
	return zh_pc_dl_file_linux_arm_deb_desc(inputs)
});
export { pc_dl_file_linux_arm_deb_desc as "pc.dl.file.linux_arm_deb.desc" }